import TilesetMenu from './TilesetMenu';
import { isClimateTileset } from '../../utils/tilesets';
import { TILESET_TYPE_ATTRIBUTE } from '../../types/tileset';

export const CLIMATE_LAYER_ID = 'climate';

const ClimateLayerMenu = () => (
  <TilesetMenu
    filterTilesets={isClimateTileset}
    title="Climate Factors"
    type={TILESET_TYPE_ATTRIBUTE}
  />
);

export default ClimateLayerMenu;
